export { LegalTypes, LegalActions } from './legal.redux';

export * from './legal.selectors';
